import { render, staticRenderFns } from "./OsCard.vue?vue&type=template&id=66dfb44a&scoped=true&"
import script from "./OsCard.vue?vue&type=script&lang=js&"
export * from "./OsCard.vue?vue&type=script&lang=js&"
import style0 from "./OsCard.vue?vue&type=style&index=0&id=66dfb44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfb44a",
  null
  
)

export default component.exports